import { FC } from 'react';
import styles from './LoadingIndeterminate.module.css';
import type { LoadingIndeterminateProps } from './LoadingIndeterminate.types';

export const LoadingIndeterminate: FC<LoadingIndeterminateProps> = () => {
  return (
    <div className={styles.progressBarContainer}>
      <div className={styles.progressBarIndicator} />
    </div>
  );
};
